// extracted by mini-css-extract-plugin
export default {"container":"EditorTextDecoration_container__j5tBZ","button":"EditorTextDecoration_button__RNul-","active":"EditorTextDecoration_active__WRAOa"};